import OrderConfirmationLayout from './OrderConfirmationLayout';

export default OrderConfirmationLayout;
